module.exports = __webpack_public_path__ + "img/2.0692a566.png";